export interface RegistrationModelSerialRequest {
  uid: string;
  modelNumber?: string;
  serialNumber?: string;
}
